import { prepareHtml } from 'core/common/utils/prepareHtml';
import Steps from './Steps';
import { UpsellsStepper } from './UpsellsStepper';
import {
  BannerStyled,
  BannerTitleWrapperStyled,
  BannerTextStyled,
  BannerTitleStyled,
  SmileEmojiStyled,
  SubtitleStyled,
  TitleStyled,
} from './styled';

type Step = Array<string> | string;

type Steps = Array<{ step: Step; title: string }>;

type UpsellsHeaderProps = {
  title?: string;
  subtitle?: string;
  bannerTitle?: string;
  bannerText?: string;
  bannerEmoji?: string;
  shouldDisplayBanner?: boolean;
  upsellsSteps?: Steps;
};

export const UpsellsHeader = ({
  title,
  subtitle,
  bannerTitle,
  bannerText,
  bannerEmoji,
  shouldDisplayBanner = false,
  upsellsSteps,
}: UpsellsHeaderProps) => {
  return (
    <>
      {/* todo Remove this condition after the upsellsSteps field is filled in all flows  */}
      {upsellsSteps ? <UpsellsStepper steps={upsellsSteps} /> : <Steps />}

      {shouldDisplayBanner && (
        <BannerStyled>
          {bannerEmoji && <SmileEmojiStyled emoji={bannerEmoji} />}
          <BannerTitleWrapperStyled>
            <BannerTitleStyled dangerouslySetInnerHTML={prepareHtml(bannerTitle)} />
            <BannerTextStyled dangerouslySetInnerHTML={prepareHtml(bannerText)} />
          </BannerTitleWrapperStyled>
        </BannerStyled>
      )}

      {title && <TitleStyled dangerouslySetInnerHTML={prepareHtml(title)} />}
      {subtitle && <SubtitleStyled dangerouslySetInnerHTML={prepareHtml(subtitle)} />}
    </>
  );
};
